import { styled } from '@mui/material';

export const UlStyled = styled('ul')({
  fontSize: '14px',
  fontWeight: '400',
  listStyleType: 'disc',
  paddingLeft: '4px',
});
